<template>
    <div id="page-wrapper">
        <div id="page-container" class="header-fixed-top sidebar-d-none d-lg-block d-xl-none-full" v-bind:class="{ 'sidebar-visible-lg-full' : sidebarFull, 'sidebar-visible-lg-mini' : sidebarMini }">
        <alternative-sidebar/>
        <sidebar/>
        <div id="main-container">
            <header-app @sidebarToggle="sidebarToggle" />
            <div id="page-content">
                <breadcrumb :list="list"/>
                <router-view/>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
import AlternativeSidebar from '@@/layout/AlternativeSidebar'
import Sidebar from '@@/layout/Sidebar'
import HeaderApp from '@@/layout/Header'

export default {
    data: () => {
        return {
            sidebarFull: true,
            sidebarMini: false
        }
    },
    computed: {
        list() {
          return this.$route.matched.filter(
            route => route.name || route.meta.label
          );
        }
    },
    methods: {
        sidebarToggle() {
            this.sidebarFull = !this.sidebarFull;
            this.sidebarMini = !this.sidebarMini;
        }
    },
    components: {
        AlternativeSidebar, Sidebar, HeaderApp,
        Breadcrumb: () => import('@@/layout/Breadcrumb')
    },
}
</script>

